function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "22",
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: "17.936",
  cy: "17.936",
  r: "17.936"
})), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "map/zoom1/Meldebuttton",
  transform: "translate(-282 -574)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Navi3",
  transform: "translate(0 559)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(17 16)"
}, /*#__PURE__*/React.createElement("g", {
  id: "button/map/fixhere-copy",
  transform: "translate(266)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Location-Button-Copy"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Oval",
  stroke: "#FFC7E8",
  strokeWidth: ".5",
  fill: "#FAC928",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "color/white",
  mask: "url(#mask-2)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h58v58H0z",
  transform: "translate(-9.257 -9.836)",
  id: "Rectangle"
})), /*#__PURE__*/React.createElement("path", {
  d: "M26.62 13.729l-3.69 3.69a1.98 1.98 0 01-2.769 0l-1.709-1.708a1.98 1.98 0 010-2.768l3.691-3.69c-2.665-.958-5.775-.411-7.928 1.742-2.12 2.119-2.7 5.229-1.743 7.86L-3.113 34.44a3.197 3.197 0 000 4.545 3.197 3.197 0 004.546 0L16.983 23.4c2.666.957 5.741.376 7.86-1.743 2.187-2.153 2.734-5.262 1.777-7.928zM-1.015 37.902a1.022 1.022 0 01-1.015-1.015c0-.54.475-1.016 1.015-1.016.54 0 1.015.476 1.015 1.016 0 .539-.444 1.015-1.015 1.015z",
  id: "Shape",
  fill: "#000",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})))))))));